

export default function GTitle({ children }) {
    return (
        <div className="gtitle flex-row-center-center">
            <span>{children}</span>
        </div>
    )
}
